module.exports = __webpack_public_path__ + "img/icon_agreement_normal@3x.aecca9c6.png";